import api from "./api";

const DesignScaleService = {
  // ─── Settings ───
  getSettings: () => api.get("/design-scale/settings"),
  createSetting: (data) => api.post("/design-scale/settings", data),
  updateSetting: (id, data) => api.put(`/design-scale/settings/${id}`, data),
  deleteSetting: (id) => api.delete(`/design-scale/settings/${id}`),
  getPendingSettings: () => api.get("/design-scale/settings/pending"),
  approveSetting: (id) => api.post(`/design-scale/settings/${id}/approve`),

  // ─── Template Groups ───
  getGroups: (params) => api.get("/design-scale/groups", { params }),
  getGroup: (id) => api.get(`/design-scale/groups/${id}`),
  createGroup: (data) => api.post("/design-scale/groups", data),
  updateGroup: (id, data) => api.put(`/design-scale/groups/${id}`, data),
  deleteGroup: (id) => api.delete(`/design-scale/groups/${id}`),
  getMatrix: (id, params) => api.get(`/design-scale/groups/${id}/matrix`, { params }),

  // ─── Variants ───
  updateVariant: (id, data) => api.put(`/design-scale/variants/${id}`, data),
  deleteVariantSku: (id) => api.delete(`/design-scale/variant-skus/${id}`),

  // ─── Unassigned SKUs ───
  getUnassignedSkus: (params) => api.get("/design-scale/unassigned-skus", { params }),
  exportUnassignedSkus: () => api.get("/design-scale/unassigned-skus/export", { responseType: "blob" }),
  bulkAssign: (data) => api.post("/design-scale/assign", data),

  // ─── Lookup ───
  lookupSku: (sku) => api.get("/design-scale/lookup", { params: { sku } }),

  // ─── Parser ───
  previewParse: (data) => api.post("/design-scale/parse/preview", data),
  runParse: (data) => api.post("/design-scale/parse/run", data),

  // ─── Win Criteria ───
  getWinCriteria: (params) => api.get("/design-scale/win-criteria", { params }),
  createWinCriteria: (data) => api.post("/design-scale/win-criteria", data),
  updateWinCriteria: (id, data) => api.put(`/design-scale/win-criteria/${id}`, data),
  deleteWinCriteria: (id) => api.delete(`/design-scale/win-criteria/${id}`),
};

export default DesignScaleService;
